import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import Login from '@/views/login/Login.vue'
import Welcome from '@/views/home/welcome.vue'
import Home from '@/views/home/Home.vue'
import { routerMode } from '@/config'
import { routesWhiteList } from '@/config'

//解决冗余
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  //预览富文本
  {
    path: '/previewEditor', component: () => import('@/views/preview/previewEditor'), meta: {
      title: '预览文章',
      addToMenu: true
    }
  },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },

      //轮播图管理
      {
        path: '/banner', component: () => import('@/views/banner/banner'), meta: {
          title: '首页轮播图管理',
          addToMenu: true
        }
      },

      //标签管理
      {
        path: '/label', component: () => import('@/views/label/label'), meta: {
          title: '标签管理',
          addToMenu: true
        }
      },

      //文章管理
      {
        path: '/article', component: () => import('@/views/article/article'), meta: {
          title: '文章管理',
          addToMenu: true
        }
      },

      //管理员管理
      {
        path: '/administrator', component: () => import('@/views/user/administrator'), meta: {
          title: '管理员管理',
          addToMenu: true
        }
      },

      //球场管理列表
      {
        path: '/court', component: () => import('@/views/court/court'), meta: {
          title: '球场管理',
          addToMenu: true
        }
      },

      //新增球场管理
      {
        path: '/addCourt', component: () => import('@/views/court/addCourt'), meta: {
          title: '新增球场管理',
          addToMenu: true
        }
      },

      //修改球场管理
      {
        path: '/modifyDetails', component: () => import('@/views/court/modifyDetails'), meta: {
          title: '修改球场管理',
          addToMenu: true
        }
      },

      //修改球场管理
      {
        path: '/editCourt', component: () => import('@/views/court/editCourt'), meta: {
          title: '修改球场管理',
          addToMenu: true
        }
      },

      //查看球场详情
      {
        path: '/viewDetails', component: () => import('@/views/court/viewDetails'), meta: {
          title: '查看球场详情',
          addToMenu: true
        }
      },

      //旅行管理列表
      {
        path: '/travel', component: () => import('@/views/travel/travel'), meta: {
          title: '旅行管理',
          addToMenu: true
        }
      },

      //新增旅行
      {
        path: '/addTravel', component: () => import('@/views/travel/addTravel'), meta: {
          title: '新增旅行',
          addToMenu: true
        }
      },

      //修改旅行
      {
        path: '/editTravel', component: () => import('@/views/travel/editTravel'), meta: {
          title: '修改旅行',
          addToMenu: true
        }
      },

      //查看旅行
      {
        path: '/viewTravel', component: () => import('@/views/travel/viewTravel'), meta: {
          title: '查看旅行',
          addToMenu: true
        }
      },

      //404
      {
        path: '/order', component: () => import('@/views/404'), meta: {
          title: '订单管理',
          addToMenu: true
        }
      },

      //球场订单列表
      {
        path: '/diamondOrder', component: () => import('@/views/order/diamondOrder'), meta: {
          title: '球场订单列表',
          addToMenu: true
        }
      },

      //修改球场订单
      {
        path: '/modifyDiamondOrder', component: () => import('@/views/order/modifyDiamondOrder'), meta: {
          title: '修改球场订单',
          addToMenu: true
        }
      },

      //旅行订单列表
      {
        path: '/travelOrder', component: () => import('@/views/order/travelOrder'), meta: {
          title: '旅行订单列表',
          addToMenu: true
        }
      },

      //修改旅行订单
      {
        path: '/modifyTravelOrder', component: () => import('@/views/order/modifyTravelOrder'), meta: {
          title: '修改旅行订单',
          addToMenu: true
        }
      },

      //商品订单列表
      {
        path: '/productOrder', component: () => import('@/views/order/productOrder'), meta: {
          title: '商品订单列表',
          addToMenu: true
        }
      },

      //修改订单列表
      {
        path: '/modifyOrderList', component: () => import('@/views/order/modifyOrderList'), meta: {
          title: '修改订单列表',
          addToMenu: true
        }
      },

      //取消订单列表
      {
        path: '/cancelOrderList', component: () => import('@/views/order/cancelOrderList'), meta: {
          title: '取消订单列表',
          addToMenu: true
        }
      },

      //商品管理列表
      {
        path: '/goods', component: () => import('@/views/goods/goods'), meta: {
          title: '商品管理',
          addToMenu: true
        }
      },

      //商品管理列表
      {
        path: '/gameOrder', component: () => import('@/views/order/gameOrder'), meta: {
          title: '比赛订单',
          addToMenu: true
        }
      },

      //修改比赛订单
      {
        path: '/modifyGameOrder', component: () => import('@/views/order/modifyGameOrder'), meta: {
          title: '修改比赛订单',
          addToMenu: true
        }
      },

      //修改
      {
        path: '/editGoods', component: () => import('@/views/goods/editGoods'), meta: {
          title: '商品管理',
          addToMenu: true
        }
      },

      //商品管理列表
      {
        path: '/sale', component: () => import('@/views/sale/sale'), meta: {
          title: 'SALE管理',
          addToMenu: true
        }
      },

      //定制商品管理列表
      {
        path: '/customGoods', component: () => import('@/views/customGoods/customGoods'), meta: {
          title: '定制商品管理',
          addToMenu: true
        }
      },

      //商品管理列表
      {
        path: '/saleOrder', component: () => import('@/views/order/saleOrder'), meta: {
          title: 'SALE订单管理',
          addToMenu: true
        }
      },

      //比赛管理
      {
        path: '/gameManagement', component: () => import('@/views/gameManagement/gameManagement'), meta: {
          title: '比赛管理',
          addToMenu: true
        }
      },
      //比赛管理
      {
        path: '/publicGame', component: () => import('@/views/gameManagement/publicGame/index'), meta: {
          title: '公开比赛',
          addToMenu: true
        }
      },

      {
        path: '/classify', component: () => import('@/views/goods/classify'), meta: {
          title: '分类管理',
          addToMenu: true
        }
      },

      {
        path: '/brand', component: () => import('@/views/goods/brand'), meta: {
          title: '品牌管理',
          addToMenu: true
        }
      },

      //新增商品
      {
        path: '/addGoods', component: () => import('@/views/goods/addGoods'), meta: {
          title: '新增商品',
          addToMenu: true
        }
      },

      //查看商品
      {
        path: '/viewGoods', component: () => import('@/views/goods/viewGoods'), meta: {
          title: '查看商品',
          addToMenu: true
        }
      },

      //用户及积分管理
      {
        path: '/user', component: () => import('@/views/user/user'), meta: {
          title: '用户及积分管理',
          addToMenu: true
        }
      },

      //地址管理 / 热门城市
      {
        path: '/popularCities', component: () => import('@/views/addressManagement/popularCities'), meta: {
          title: '热门城市',
          addToMenu: true
        }
      },

      //地址管理 / 地址排序
      {
        path: '/addressSort', component: () => import('@/views/addressManagement/addressSort'), meta: {
          title: '地址排序',
          addToMenu: true
        }
      },

      //404
      {
        path: '/404', component: () => import('@/views/404'), meta: {
          title: '404',
          addToMenu: true
        }
      },

      //菜单
      {
        path: '/menu', component: () => import('@/views/system/menu'), meta: {
          title: '菜单管理',
          addToMenu: true
        }
      },

      //角色
      {
        path: '/role', component: () => import('@/views/system/role'), meta: {
          title: '角色管理',
          addToMenu: true
        }
      },

      //字典管理
      {
        path: '/dict', component: () => import('@/views/system/dict'), meta: {
          title: '字典管理',
          addToMenu: true
        }
      },

      //富文本
      {
        path: '/tiptap', component: () => import('@/views/tiptap/tiptap'), meta: {
          title: '富文本',
          addToMenu: true
        }
      },

      // 地图测试
      {
        path: '/map', component: () => import('@/views/map/map'), meta: {
          title: '地图测试',
          addToMenu: true
        }
      },

      // 广告
      {
        path: '/advertise', component: () => import('@/views/advertise/advertise'), meta: {
          title: '广告管理',
          addToMenu: true
        }
      },

      // 广告
      {
        path: '/Timetable', component: () => import('@/views/Timetable/Timetable'), meta: {
          title: '测试',
          addToMenu: true
        }
      },

      // 修改球场
      {
        path: '/updateCourtOrder', component: () => import('@/views/order/update/updateCourtOrder'), meta: {
          title: '修改球场订单',
          addToMenu: true
        }
      },

      // 修改比赛
      {
        path: '/updateGameOrder', component: () => import('@/views/order/update/updateGameOrder'), meta: {
          title: '修改比赛',
          addToMenu: true
        }
      },
      // 修改比赛
      {
        path: '/updateRaceRaise', component: () => import('@/views/order/update/updateRaceRaise'), meta: {
          title: '修改公开比赛',
          addToMenu: true
        }
      },
      // 修改比赛
      {
        path: '/updateRaceApply', component: () => import('@/views/order/update/updateRaceApply'), meta: {
          title: '修改公开比赛报名',
          addToMenu: true
        }
      },

      //修改旅行
      {
        path: '/updateTravelOrder', component: () => import('@/views/order/update/updateTravelOrder'), meta: {
          title: '修改旅行订单',
          addToMenu: true
        }
      },

      //优惠券
      {
        path: '/coupon', component: () => import('@/views/coupon/coupon'), meta: {
          title: '优惠券管理',
          addToMenu: true
        }
      },

      //用户优惠券使用
      {
        path: '/userCoupon', component: () => import('@/views/coupon/userCoupon'), meta: {
          title: '用户优惠券使用管理',
          addToMenu: true
        }
      },

      // 消券记录页面
      {
        path: '/eliminateCoupon',component: () => import('@/views/coupon/eliminateCoupon'), meta: {
          title: '消券记录',
          addToMenu: true
        }
      },

      // 饭店信息查询页面
      {
        path: '/restaurant',component: () => import('@/views/restaurant/restaurant'), meta: {
          title: '饭店信息列表',
          addToMenu: true
        }
      },

      // 新增饭店信息页面
      {
        path: '/editRestaurant',component: () => import('@/views/restaurant/editRestaurant'), meta: {
          title: '新增饭店信息',
          addToMenu: true
        }
      },

      // 饭店优惠券购买审核查询页面
      {
        path: '/restaurantUseCoupon',component: () => import('@/views/restaurant/restaurantUseCoupon'), meta: {
          title: '饭店优惠券购买审核列表',
          addToMenu: true
        }
      },

      // 饭店优惠券购买审核查询记录页面
      {
        path: '/restaurantCouponRecord',component: () => import('@/views/restaurant/restaurantCouponRecord'), meta: {
          title: '饭店优惠券购买审核记录列表',
          addToMenu: true
        }
      },
    ]
  }


]
const router = new VueRouter({
  mode: routerMode,
  routes
})

function auth() {
  const token = sessionStorage.getItem('token')
  const cookieToken = Cookies.get('token')
  return !!(token || cookieToken)
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // 如果当前路由有meta值
    document.title = to.meta.title + ' - ' + 'Blue Tee'
  } else {
    // 如果没有meta值，就显示默认值
    document.title = 'Blue Tee'
  }
  if (routesWhiteList.indexOf(to.path) !== -1) {
    return next()
  }
  if (!auth()) {
    return next('/login')
  }
  next()
})

export default router


